import { FilterCriteria } from '@/filterCriteria/types';

export const DEFAULT_TASK_CHOICES = [
  { id: 89, label: 'Active/Rostered/Confirmed' },
  { id: 69, label: 'Interested' },
];

export const DEFAULT_DRAWER_NAME = 'New search';

export const filterInitialState: FilterCriteria = {
  geometries: [],
  locationOperator: 'lives in',
  groups: [],
  tags: [],
  contactable: {},
  lists: [],
  statuses: [],
  eventTypes: [],
  events: [],
  eventCampaigns: [],
  eventDateRange: { startDate: null, endDate: null },
  election: null,
  electorates: [],
  rostertypes: [{ id: 1, label: 'Rostered' }],
  rostercriteria: { votingPeriod: 'Any', shiftStatus: 'Confirmed' },
  memberships: [],
  branches: [],
  notRenewing: '',
  supporterstatuses: [],
  taskelections: [],
  issincespecificelection: false,
  taskchoices: [],
  taskkinds: [],
  tasknote: '',
  mailings: [],
  mailingstatus: undefined,
  activities: [],
  activityStatuses: [],
  activityDateRange: {
    displayedStartDate: null,
    displayedEndDate: null,
    periodValue: 'bytimeperiod',
    periodDetails: 'lastweek',
  },
  subject: '',
  age: { range: null, value: null },
  pathwaySteps: [],
  callingstatusinclusion: undefined,
  callingstatuses: [],
  callingstatusDateRange: {
    displayedStartDate: null,
    displayedEndDate: null,
    callingPeriodValue: 'withinlast',
    callingPeriodDetails: 'weeks',
    callingPeriodQuantity: 3,
  },
  callingstatusLists: [],
  callingstatusUsers: [],
  callingstatusCampaigns: [],
  commspreferencesinclusion: undefined,
  commspreferences: [],
};
